module.exports = "/assets/packs/images/0f7826b285c5c03dc9d926ccf480fdb4.png";